/* ========================================================================== 
  VIDEO EMBED PLAY
  ========================================================================== */

// youtube tag
let tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
const firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

const ytVideoEmbeds = document.querySelectorAll(".js-youtube-embed"),
    videoPlayButtons = document.querySelectorAll(".js-play-video");
let players = new Array(),
    YT;

if (typeof videoPlayButtons != "undefined" && videoPlayButtons != null) {
    videoPlayButtons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();

            let videoType = btn.dataset.type,
                videoEmbed = btn.nextElementSibling;

            if (videoType == "vimeo") {
                let vimeoPlayer = new Vimeo.Player(videoEmbed);
                vimeoPlayer.setVolume(1);
                vimeoPlayer.play();
            } else {
                let player = videoEmbed.dataset.player;
                players[player].playVideo();
            }

            gsap.to(videoEmbed, 0.3, {
                autoAlpha: 1,
                ease: Power1.easeInOut
            });
        });
    });
}

function onYouTubeIframeAPIReady() {
    for (var i = 0; i < ytVideoEmbeds.length; i++) {
        var curplayer = createPlayer(ytVideoEmbeds[i]);
        players[i] = curplayer;
    }
}

function createPlayer(videoWrapper) {
    return new YT.Player(videoWrapper, {
        height: videoWrapper.height,
        width: videoWrapper.width,
        videoId: videoWrapper.dataset.src,
        playerVars: {
            autoplay: 0,
            controls: 1,
            autohide: 1,
            origin: "window.location"
        }
    });
}
